// /forms/user/validationRules.js

export const validationRules = (formData) => ({
  firstName: {
    required: true,
    pattern: /^[A-Za-z ]+$/,
    message: "First name must contain only letters",
  },
  lastName: {
    required: true,
    pattern: /^[A-Za-z ]+$/,
    message: "Last name must contain only letters",
  },
  // preferredName: {
  //   pattern: /^[A-Za-z]*$/, // allows empty OR letters only
  //   message: "Preferred Name must contain only letters",
  // },
  preferredName: {
    required: true,
    validate: (value) => {
      if (!value) return true; // not required
      if (/\s/.test(value)) {
        return "No spaces allowed";
      }
      if (!/^[A-Za-z]*$/.test(value)) {
        return "Preferred Name must contain only letters";
      }
      return true;
    },
  },
  gender: { required: true },
  countryCode: { required: true },
  email: {
    required: true,
    pattern: /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    message: "Enter a valid email (e.g., user@example.com)",
  },
  phone: {
    required: true,
    pattern: /^\d{10}$/,
    message: "Phone must be 10 digits",
  },
  // countryCode: {
  //   required: true,
  // },
  address: { required: true },
  city: {
    required: true,
    // pattern: /^[A-Za-zÀ-ÿ\s.,&()'/-]+$/,
    pattern: /^[\p{L}\p{M}\s.,&()'/-]+$/u,
    message: "City must contain only letters",
  },
  state: {
    required: true,
    // pattern: /^[A-Za-zÀ-ÿ\s.,&()'/-]+$/,
    pattern: /^[\p{L}\p{M}\s.,&()'/-]+$/u,
    message: "State must contain only letters",
  },
  zip: { required: true },
  country: {
    required: true,
    // pattern: /^[A-Za-zÀ-ÿ\s.,&()'/-]+$/,
    pattern: /^[\p{L}\p{M}\s.,&()'/-]+$/u,
    message: "Country must contain only letters",
  },
  // isKnownUser: { required: true },
  addressConfirmation: { required: true },

  // Travel Details
  citizenship: {
    required: true,
    pattern: /^[A-Za-z ]+$/,
    message: "Country must contain only letters",
  },
  // file: { required: true },
  // passportNo: {
  //   required: true,
  //   minLength: {
  //     value: 9,
  //     message: "Passport number must be 9 characters",
  //   },
  //   maxLength: {
  //     value: 9,
  //     message: "Passport number must be 9 characters",
  //   },
  // },
  // passportExp: { required: true },

  // 👇 Conditional rules

  file: {
    required: formData.noPassport === "Yes" ? false : true,
    message: "Passport scan is required",
  },
  passportNo: {
    required: formData.noPassport === "Yes" ? false : true,
    minLength: {
      value: 9,
      message: "Passport number must be 9 characters",
    },
    maxLength: {
      value: 9,
      message: "Passport number must be 9 characters",
    },
  },
  passportExp: {
    required: formData.noPassport === "Yes" ? false : true,
    message: "Passport expiry is required",
  },

  dob: {
    required: true,
    validate: (val) => {
      if (!val) return "DOB is required.";

      const inputDate = new Date(val);
      const today = new Date();

      // Normalize both to remove time
      const inputDateOnly = new Date(
        inputDate.getFullYear(),
        inputDate.getMonth(),
        inputDate.getDate(),
      );
      const todayOnly = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
      );

      if (inputDateOnly > todayOnly) {
        return "DOB cannot be in the future.";
      }

      return true; // valid
    },
  },
  passportConfirmation: { required: true },

  // Accommodation Details
  userType: { required: true },
  Category: { required: true },
  isKnownUser: {
    required: formData.Category === "Double" && !formData.isKnownUser,
    message: "This field is required",
  },

  // Health Details
  // medicalIssues: {
  //   required: true,
  // },
  // medications: { required: true },
  // allergies: { required: true },
  // walkIssue: { required: true },
  // carSick: { required: true },
  // seaSick: { required: true },
  // foodAllergies: { required: true },
  // dietaryPreferences: { required: true },

  // Emergency Contact
  // ecFirstName: {
  //   required: true,
  //   pattern: /^[A-Za-z ]+$/,
  //   message: "First name must contain only letters",
  // },
  // ecLastName: {
  //   required: true,
  //   pattern: /^[A-Za-z ]+$/,
  //   message: "Last name must contain only letters",
  // },
  // ecPhone: {
  //   required: true,
  //   pattern: /^\d{10}$/,
  //   message: "Phone must be 10 digits",
  // },
  // ecCountry: { required: true },

  // Accommodation Details
  // party: { required: true },
  // Category: { required: true },
  // Cruise: { required: true },

  // // TourPackageOptions
  // price: { required: true },
});

export const choiceValidationRules = {
  // travelerChoice: {
  //   required: true,
  //   type: "array",
  //   minItems: 1,
  //   custom: (value) =>
  //     (Array.isArray(value) && value.length > 0) ||
  //     "At least one traveler choice is required",
  // },

  tourOptions: {
    required: true,
    type: "array",
    minItems: 1,
    custom: (value) =>
      (Array.isArray(value) && value.length > 0) ||
      "At least one tour option is required",
  },
};

export const participantValidationRules = (formData) => ({
  firstName: {
    required: true,
    pattern: /^[A-Za-z ]+$/,
    message: "First name must contain only letters",
  },
  lastName: {
    required: true,
    pattern: /^[A-Za-z ]+$/,
    message: "Last name must contain only letters",
  },
  preferredName: {
    required: true,
    validate: (value) => {
      if (!value) return true; // not required
      if (/\s/.test(value)) {
        return "No spaces allowed";
      }
      if (!/^[A-Za-z]*$/.test(value)) {
        return "Preferred Name must contain only letters";
      }
      return true;
    },
  },
  gender: { required: true },
  email: {
    required: true,
    pattern: /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    message: "Enter a valid email (e.g., user@example.com)",
  },
  phone: {
    required: true,
    pattern: /^\d{10}$/,
    message: "Phone must be 10 digits",
  },
  address: { required: true },
  city: {
    required: true,
    // pattern: /^[A-Za-zÀ-ÿ\s.,&()'/-]+$/,
    pattern: /^[\p{L}\p{M}\s.,&()'/-]+$/u,
    message: "City must contain only letters",
  },
  state: {
    required: true,
    // pattern: /^[A-Za-zÀ-ÿ\s.,&()'/-]+$/,
    pattern: /^[\p{L}\p{M}\s.,&()'/-]+$/u,
    message: "State must contain only letters",
  },
  zip: { required: true },
  country: {
    required: true,
    // pattern: /^[A-Za-zÀ-ÿ\s.,&()'/-]+$/,
    pattern: /^[\p{L}\p{M}\s.,&()'/-]+$/u,
    message: "Country must contain only letters",
  },

  citizenship: {
    required: true,
    pattern: /^[A-Za-z ]+$/,
    message: "Country must contain only letters",
  },

  // Participants Travel Details
  // file: { required: true },
  // passportNo: {
  //   required: true,
  //   minLength: {
  //     value: 9,
  //     message: "Passport number must be 9 characters",
  //   },
  //   maxLength: {
  //     value: 9,
  //     message: "Passport number must be 9 characters",
  //   },
  // },
  // passportExp: { required: true },
  file: {
    required: formData.noPassport === "Yes" ? false : true,
    message: "Passport scan is required",
  },
  passportNo: {
    required: formData.noPassport === "Yes" ? false : true,
    minLength: {
      value: 9,
      message: "Passport number must be 9 characters",
    },
    maxLength: {
      value: 9,
      message: "Passport number must be 9 characters",
    },
  },
  passportExp: {
    required: formData.noPassport === "Yes" ? false : true,
    message: "Passport expiry is required",
  },
  dob: {
    required: true,
    validate: (val) => {
      if (!val) return "DOB is required.";

      const inputDate = new Date(val);
      const today = new Date();

      // Normalize both to remove time
      const inputDateOnly = new Date(
        inputDate.getFullYear(),
        inputDate.getMonth(),
        inputDate.getDate(),
      );
      const todayOnly = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate(),
      );

      if (inputDateOnly > todayOnly) {
        return "DOB cannot be in the future.";
      }
      return true; // valid
    },
  },

  // Health Details
  // medicalIssues: {
  //   required: true,
  // },
  // medications: { required: true },
  // allergies: { required: true },
  // walkIssue: { required: true },
  // carSick: { required: true },
  // seaSick: { required: true },
  // foodAllergies: { required: true },
  // dietaryPreferences: { required: true },

  addressConfirmation: { required: true },
  passportConfirmation: { required: true },
});
